/**
 * Users endpoints
 */
export const usersEndpoints = {
  list: () => '/api/users',
  commercials: () => '/api/users/commercials',
  detail: (id) => `/api/users/${id}`,
  create: () => '/api/users',
  update: (id) => `/api/users/${id}`,
  delete: (id) => `/api/users/${id}`
}
